module.exports = "/_next/static/images/0d1ed8f9e952e490623c1d39fe5ef32d-man-holding-device-2@0.5x.jpg";